<template>
  <div v-if="isTrialActive"
       class="bg-amber-50 border-b border-amber-200 px-6 py-3">
    <div class="max-w-6xl mx-auto flex items-center justify-between gap-4 flex-wrap">
      <p class="text-sm text-amber-800">
        <span class="font-semibold">Período de prueba:</span>
        Te quedan {{ trialRemainingDays }} día{{ trialRemainingDays !== 1 ? 's' : '' }}.
        {{ trialRemainingDays === 0 ? 'Tu prueba vence hoy.' : '' }}
        <span v-if="trialRemainingDays <= 7 && promotionalPrice">
          Después, tu plan tendrá un precio de lanzamiento de ${{ formatPrice(promotionalPrice) }}/mes
          durante {{ promotionMonths }} meses.
        </span>
      </p>
      <router-link to="/billing"
        class="text-sm font-semibold text-amber-900 underline hover:no-underline whitespace-nowrap">
        Contratar plan ahora
      </router-link>
    </div>
  </div>
  <div v-else-if="isPromotionalActive"
       class="bg-blue-50 border-b border-blue-200 px-6 py-3">
    <div class="max-w-6xl mx-auto flex items-center justify-between gap-4 flex-wrap">
      <p class="text-sm text-blue-800">
        <span class="font-semibold">Precio fundador activo:</span>
        ${{ formatPrice(currentPrice) }}/mes
        <span v-if="promotionMonthNumber && promotionMonths">
          (mes {{ promotionMonthNumber }} de {{ promotionMonths }})
        </span>
      </p>
      <router-link to="/billing"
        class="text-sm font-semibold text-blue-900 underline hover:no-underline whitespace-nowrap">
        Ver detalle
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TrialCountdownBanner',
  computed: {
    ...mapGetters({
      isTrialActive: 'billing/isTrialActive',
      trialRemainingDays: 'billing/trialRemainingDays',
      isPromotionalActive: 'billing/isPromotionalActive',
      currentPrice: 'billing/currentPrice',
      promotionMonthNumber: 'billing/promotionMonthNumber',
    }),
    promotionalPrice() {
      return this.$store.state.billing.subscription?.promotional_price_ars || null;
    },
    promotionMonths() {
      return this.$store.state.billing.subscription?.promotion_months || null;
    },
  },
  methods: {
    formatPrice(value) {
      if (value === null || value === undefined) return '';
      return Number(value).toLocaleString('es-AR');
    },
  },
};
</script>
